import { Switch } from "../../Switch/index.js";
import { CalendarButton } from "./Calendar/Button.js";
import { CalendarGrid } from "./Calendar/CalendarGrid.js";
import React from "react";
import { IconArrowLeft, IconArrowRight } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { useLocale, useRangeCalendar } from "react-aria";
import { useRangeCalendarState } from "react-stately";
import { createCalendar } from "@internationalized/date";
//#region src/DatePicker/components/RangeCalendar.tsx
const RangeCalendar = (props) => {
	const { locale } = useLocale();
	const state = useRangeCalendarState({
		...props,
		locale,
		createCalendar
	});
	const ref = React.useRef(null);
	const { calendarProps, prevButtonProps, nextButtonProps, title } = useRangeCalendar(props, state, ref);
	const footer = props.onClear && /* @__PURE__ */ jsxs("div", {
		className: "border-neutrals-90 data-[time-visible='true']:(justify-between px-6) flex justify-center border-t border-solid py-4",
		"data-time-visible": props.onTimeVisibleChange ? "true" : "false",
		children: [props.onTimeVisibleChange && /* @__PURE__ */ jsx(Switch, {
			name: "time-visible",
			label: "Время",
			size: "md",
			onCheckedChange: props.onTimeVisibleChange,
			checked: props.timeVisible
		}), /* @__PURE__ */ jsx("button", {
			className: "text-type-minor bg-transparent px-4 py-2 font-sans text-base font-medium outline-none",
			onClick: props.onClear,
			type: "button",
			children: "Сбросить"
		})]
	});
	return /* @__PURE__ */ jsxs("div", {
		...calendarProps,
		ref,
		className: cn("text-neutrals-60 inline-block", props.className),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "px-6 py-2",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "flex items-center pb-4",
				children: [
					/* @__PURE__ */ jsx(CalendarButton, {
						...prevButtonProps,
						children: /* @__PURE__ */ jsx(IconArrowLeft, { className: "text-neutrals-60 size-6" })
					}),
					/* @__PURE__ */ jsx("h2", {
						className: "text-type-minor flex-1 text-center text-sm font-medium",
						children: title
					}),
					/* @__PURE__ */ jsx(CalendarButton, {
						...nextButtonProps,
						children: /* @__PURE__ */ jsx(IconArrowRight, { className: "text-neutrals-60 size-6" })
					})
				]
			}), /* @__PURE__ */ jsx(CalendarGrid, { state })]
		}), footer]
	});
};
//#endregion
export { RangeCalendar };

//# sourceMappingURL=RangeCalendar.js.map